import React from 'react';
import { CardElement } from 'react-stripe-elements';
import Label from 'components/Label';
import Row from 'components/Row';
import Text from 'components/Text';

type Props = {
  onCardInputCompleteChange: (complete: boolean) => void;
  onSetCardFailureReason: (cardFailureReason?: string | null) => void;
  onFocusCardElement?: () => void;
  cardFailureReason?: null | string;
};

export default function TutoringSelfServeViewBillingCard(props: Props) {
  const {
    cardFailureReason,
    onFocusCardElement,
    onCardInputCompleteChange,
    onSetCardFailureReason,
  } = props;
  return (
    <React.Fragment>
      <Row size="xxsmall">
        <Label htmlFor="cardnumber">Credit or debit card</Label>
        <CardElement
          data-test="credit-card-input"
          className={`CoachingIsolatedView-cardInput ${cardFailureReason ? 'CoachingIsolatedView-cardInput--error' : ''
            }`}
          onChange={(e: stripe.elements.ElementChangeResponse) => {
            if (e.complete && !e.error) {
              onSetCardFailureReason(null);
              onCardInputCompleteChange(true);
            } else {
              onCardInputCompleteChange(false);
              onSetCardFailureReason(e.error?.message);
            }
          }}
          onFocus={onFocusCardElement}
        />
      </Row>
      {cardFailureReason && (
        <Row size="small">
          {/* nbsp is to hold space and prevent UI from jumping when an error appears */}
          <Text color="apple" data-test="credit-card-failure-reason">
            {cardFailureReason}&nbsp;
          </Text>
        </Row>
      )}
    </React.Fragment>
  );
}
